/**
 * Export limits WITHOUT a license key — what the free app does, enforced by the
 * desktop app itself (`src-tauri/src/license/gate.rs` at v2.0.0). THE dashboard's
 * single source for these three facts: every screen that states them renders from
 * here, and the Pro copy that says which of them a key removes builds its strings
 * from the same fields. Never type "1080p" or "30 menit" into markup again
 * (ui/DESIGN.md §9, DECISIONS D40 (2)).
 *
 * Mirrors `KEYLESS_EXPORT_LIMITS` in web/src/lib/site.ts field for field, and
 * `keylessExportRows` in web/src/lib/features.ts row for row — the dashboard
 * cannot import from the marketing app, so the two constants are kept identical
 * by hand and must be changed together.
 *
 * Nothing here describes Pro or module availability. Every module is open
 * without a key since desktop 2.29.6 (D40 (8), resolved 2026-10-03); the
 * marketing pages say so, this module only holds the export limits.
 */

export const KEYLESS_EXPORT_LIMITS = {
  maxResolution: "1080p",
  maxMinutes: 30,
  endCardText: "ahcut.com",
  endCardSeconds: 2,
} as const;

const { maxResolution, maxMinutes, endCardText, endCardSeconds } = KEYLESS_EXPORT_LIMITS;

/** The keyless limits as term/value rows — same labels and wording as the marketing pages. */
export const keylessExportRows: readonly { term: string; value: string }[] = [
  { term: "Resolusi maksimal", value: maxResolution },
  { term: "Durasi maksimal", value: `${maxMinutes} menit` },
  { term: "Akhir video", value: `Kartu penutup “${endCardText}” selama ${endCardSeconds} detik` },
  // D34 removed the per-frame corner stamp: the end card is the only mark.
  { term: "Tanda di tiap frame", value: "Tidak ada" },
];
